
import {of as observableOf,  Observable } from 'rxjs';

import {share, tap, map} from 'rxjs/operators';
import { Injectable } from "@angular/core";





import {
    CountryVM,
    CallingCodeVM,
    CurrencyVM,
    NationalityVM,
    CounsellingTopicVM,
    ReasonForMedicationVM,
    GlobalSettingsVM
} from "../models";
import { LanguageVM } from "../models/LanguageVM";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class ReferenceDataService {

    private globalSettings: GlobalSettingsVM;
    private countries: CountryVM[];
    private callingCodes: CallingCodeVM[];
    private states: string[];
    private nationalities: NationalityVM[];
    private currencies: CurrencyVM[];
    private languages: LanguageVM[];

    constructor(private http: HttpClient)
    {

    }

    public getGlobalSettings(): Observable<GlobalSettingsVM> {
        if (this.globalSettings) return observableOf(this.globalSettings);

        return this.http.get('/api/reference/settings', this.getHttpOptions(false)).pipe(
            map(resp => resp as GlobalSettingsVM),
            tap(settings => {
                this.globalSettings = settings;
            }),
            share(),);
    }

    public getCountries(enabledOnly: boolean): Observable<CountryVM[]> {
        if (this.countries) return observableOf(this.countries);

        return this.http.get('/api/reference/countries/' + enabledOnly.toString(), this.getHttpOptions(false)).pipe(
            map((resp) => resp as CountryVM[]),
            tap(countries => {
                this.countries = countries;
            }),
            share(),);
  }

  public getStates(): Observable<string[]> {
    if (this.states) return observableOf(this.states);

    return this.http.get('/api/reference/states/', this.getHttpOptions(false)).pipe(
      map((resp) => resp as string[]),
      tap(states => {
        this.states = states;
      }),
      share(),);
  }

    public getCallingCodes(): Observable<CallingCodeVM[]> {
        if (this.callingCodes) return observableOf(this.callingCodes);

        return this.http.get('/api/reference/callingcodes', this.getHttpOptions(false)).pipe(
            map((resp) => resp as CallingCodeVM[]),
            tap(callingCodes => {
                this.callingCodes = callingCodes;
            }),
            share(),);
    }

    public getCurrencies(): Observable<CurrencyVM[]> {
        if (this.currencies) return observableOf(this.currencies);

        return this.http.get('/api/reference/currencies', this.getHttpOptions(false)).pipe(
            map((resp) => resp as CurrencyVM[]),
            tap(currencies => {
                this.currencies = currencies;
            }),
            share(),);
    }

    public getLanguages(): Observable<LanguageVM[]> {
        if (this.languages) return observableOf(this.languages);

        return this.http.get('/api/reference/languages', this.getHttpOptions(false)).pipe(
            map((resp) => resp as LanguageVM[]),
            tap(languages => {
                this.languages = languages;
            }),
            share(),);
    }

    public getNationalities(): Observable<NationalityVM[]> {
        if (this.nationalities) return observableOf(this.nationalities);

        return this.http.get('/api/reference/nationalities', this.getHttpOptions(false)).pipe(
            map((resp) => resp as NationalityVM[]),
            tap(nationalities => {
                this.nationalities = nationalities;
            }),
            share(),);
    }

    public getCounsellingTopics(): Observable<CounsellingTopicVM[]> {
        return this.http.get('/api/reference/counsellingtopics', this.getHttpOptions(false)).pipe(
            map((resp) => resp as CounsellingTopicVM[]));
    }

    public getMedicationReasons(): Observable<ReasonForMedicationVM[]> {
        return this.http.get('/api/reference/reasonsformedication', this.getHttpOptions(false)).pipe(
            map((resp) => resp as ReasonForMedicationVM[]));
    }

    protected getHttpOptions (authenticated: boolean, params?: URLSearchParams) {
        if (authenticated) {
            const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            });
            return { headers };
        }
        else {
            let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
            return (params != null) ? { headers, search: params } : { headers };
        }
    }

}
